export enum ImportErrorType {
    INFO,
	WARNING,
	FATAL
}